import { geographyBranchLabels } from '../constants/branch-labels';
import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type TreeFilter } from '../types/filters';

export const hqLocationDefinition: FilterDefinition<TreeFilter> = {
  id: FilterId.HQ_LOCATION,
  name: 'HQ Location',
  selectionListIds: ['region', 'country', 'msa'],
  selections: [],
  branches: geographyBranchLabels,
  type: FilterType.TREE,
  isVisible: true,
};

export const hqLocationHandler: FilterHandler<TreeFilter> = {
  isActive(currentFilterState: TreeFilter) {
    return currentFilterState.selections.length > 0;
  },
  isDefault(currentFilterState: TreeFilter) {
    return currentFilterState.selections.length === 0;
  },
  getEffectiveFilter(currentFilterState: TreeFilter) {
    return { ...currentFilterState };
  },
  getRequiredSelectionListIds(definition: FilterDefinition<TreeFilter>) {
    return definition.selectionListIds;
  },
};
